import { Pagination } from "../../Atoms/Pagination";
import dayjs from "dayjs";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { useIncidentHistorySchedule } from "./useIncidentHistorySchedule";
import { FileContainer } from "../../Atoms/FileContainer";
import * as S from "./styles";

export const IncidentHistorySchedule = () => {
    const { events, isMobile, pagination, setNumberPage, handleDownloadFile } = useIncidentHistorySchedule();
    return (
        <>
        <S.WrapperTimeLine>
            <VerticalTimeline
            animate={false}
            layout="1-column-left"
            lineColor="#9D9D9D"
            >
            {events?.length > 0 &&
                events?.map((event, index) => (
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{
                    background: index % 2 === 0 ? "#E8E8E8" : "#F7F7F7",
                    borderRadius: "10px",
                    boxShadow: "none",
                    height: "fit-content",
                    display: "flex",
                    }}
                    contentArrowStyle={{
                    borderRight: `10px solid ${
                        index % 2 === 0 ? "#E8E8E8" : "#F7F7F7"
                    }`,
                    }}
                    iconStyle={{
                    background: "#9D9D9D",
                    width: "12px",
                    height: "12px",
                    left: "14px",
                    top: "16px",
                    boxShadow: "none",
                    }}
                >
                    <S.TimeLineContent>
                        <span>{`${dayjs(event?.createdAt).format("DD/MM/YYYY - HH:mm")}`}</span>
                        <p>{event?.outroMotivo ? "Outro motivo" : event?.motivo?.descricao || "---"}</p>
                        <p>{event?.observacao}</p>
                        <div className="flex gap-3 flex-wrap">
                            {event?.arquivos?.length > 0 &&
                                event?.arquivos.map((f) => (
                                <FileContainer
                                    key={f.uuid}
                                    name={f?.fileName}
                                    size={f?.size}
                                    type="download"
                                    handleClick={() => handleDownloadFile(f)}
                                />
                                ))
                            }
                        </div>
                    </S.TimeLineContent>
                </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
        </S.WrapperTimeLine>

        {events?.length > 0 && (
            <S.WrapperPagination>
            <Pagination
                maxPageNumbersDisplayed={isMobile ? 3 : 10}
                key={`${Math.random()} - ${pagination}`}
                totalPage={pagination?.totalPage}
                totalRegister={pagination?.totalPage}
                actualPage={pagination?.actualPage}
                setNumberPage={setNumberPage}
            />
            </S.WrapperPagination>
        )}
        </>
    );
};